var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistrationConsentMedicalForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M49.954 7c.781 0 1.42.593 1.492 1.354l.007.145v5.796h8.028c.781 0 1.42.593 1.492 1.354l.007.145v47.998c0 .781-.593 1.42-1.354 1.492l-.145.007h-36.46c-.781 0-1.42-.593-1.492-1.354l-.007-.145v-5.796h-8.023c-.781 0-1.42-.593-1.492-1.354L12 56.497V8.499c0-.781.593-1.42 1.354-1.492L13.5 7h36.455Zm8.028 10.293H24.52v45h33.462v-45Zm-9.527-7.295H14.998v45h6.524V15.794c0-.781.593-1.42 1.354-1.492l.145-.007h25.434V9.998Zm-.6 31.704c.83 0 1.499.67 1.499 1.5 0 .78-.593 1.42-1.355 1.492l-.144.006h-18.37c-.83 0-1.498-.669-1.498-1.499 0-.78.592-1.42 1.354-1.492l.145-.007h18.369Zm4.624-8.535c.83 0 1.499.67 1.499 1.5 0 .78-.593 1.419-1.355 1.491l-.144.007H29.486c-.83 0-1.5-.669-1.5-1.499 0-.781.593-1.42 1.355-1.492l.145-.007h22.993Zm0-8.53c.83 0 1.498.669 1.498 1.499 0 .781-.592 1.42-1.354 1.492l-.145.007H29.485c-.83 0-1.499-.669-1.499-1.499 0-.781.593-1.42 1.355-1.492l.144-.007h22.993Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationConsentMedicalForm);
export default __webpack_public_path__ + "static/media/RegistrationConsentMedicalForm.c081d95638e0561b7a9b21d7d02f06ab.svg";
export { ForwardRef as ReactComponent };